import apiService from './apiService';

export const notificationsService = {
  async getNotifications(params?: any): Promise<any> {
    return apiService.get('/notifications', { params });
  },

  async getUnread(): Promise<any> {
    return apiService.get('/notifications', { params: { read: false } });
  },

  async getUnreadCount(): Promise<any> {
    return apiService.get('/notifications/unread-count');
  },

  async markAsRead(id: string): Promise<void> {
    return apiService.put(`/notifications/${id}`, { read: true });
  },

  async markAllAsRead(): Promise<void> {
    return apiService.put('/notifications/read-all');
  },

  async deleteNotification(id: string): Promise<void> {
    return apiService.delete(`/notifications/${id}`);
  },

  async archiveNotification(id: string): Promise<void> {
    return apiService.put(`/notifications/${id}`, { archived: true });
  },

  async deleteAll(): Promise<void> {
    return apiService.delete('/notifications');
  },

  async getPreferences(): Promise<any> {
    return apiService.get('/notifications/preferences');
  },

  async updatePreferences(preferences: any): Promise<any> {
    return apiService.put('/notifications/preferences', preferences);
  },

  async create(notification: {
    type: string;
    title: string;
    message: string;
    priority?: string;
    data?: any;
  }): Promise<any> {
    return apiService.post('/notifications', notification);
  },

  async sendTestDigest(userId: string, type: 'daily' | 'weekly'): Promise<any> {
    return apiService.post('/notifications/digest', { userId, type });
  },
};
